import React from 'react';
import '../App.css';
import Sidebar from './Sidebar.js';



export const Header = () => {
    
    return (
        <>
         <Sidebar/>
        <div className="header">
        <div className="name-div">
        <h1 id='name'>Play <p className='flicker'>it!</p></h1>
        </div>
        <div className="ghost-div">
        <img id='ghost' src={"../img/ghost.png"} alt="Quiz" width={150} height={150}></img>
        </div>
       </div>
</>
    );
};